/**
 * Logger utility that wraps console methods and can be easily disabled.
 * Set DEBUG_LOGGING to false to disable all log/warn output.
 * console.error is always enabled for critical errors.
 */

const DEBUG_LOGGING = false; // Set to true to enable logging

export const logger = {
  log: (...args: any[]) => {
    if (DEBUG_LOGGING) {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (DEBUG_LOGGING) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    // Always log errors
    console.error(...args);
  },
  debug: (...args: any[]) => {
    if (DEBUG_LOGGING) {
      console.debug(...args);
    }
  },
  info: (...args: any[]) => {
    if (DEBUG_LOGGING) {
      console.info(...args);
    }
  }
};

export default logger;

